export const errorHandler = (errorsObj, translate) => {
  if (errorsObj?.info) {
    if (
      typeof errorsObj?.info === 'string' &&
      (errorsObj?.info.includes('surname: Surname is not correct, name: Name is not correct') ||
        errorsObj?.info.includes('name: Name is not correct, surname: Surname is not correct'))
    ) {
      return "Ім'я та прізвище не коректні!";
    } else if (
      typeof errorsObj?.info === 'string' &&
      errorsObj?.info.includes('surname: Surname is not correct') &&
      !errorsObj?.info.includes('name: Name is not correct')
    ) {
      return 'Прізвище не коректне!';
    } else if (
      typeof errorsObj?.info === 'string' &&
      errorsObj?.info.includes('name: Name is not correct') &&
      !errorsObj?.info.includes('surname: Surname is not correct')
    ) {
      return "Ім'я не коректне!";
    }
    if (errorsObj?.info?.user === "User doesn't exists") {
      return errorsObj;
    } else if (errorsObj?.info?.verify === 'No such key') {
      return 'Некоректний тимчасовий ключ';
    } else if (
      errorsObj?.info?.email &&
      errorsObj?.info?.email.includes('There is an account with that email address')
    ) {
      return 'Акаунт з такою поштою вже існує';
    } else if (errorsObj?.info?.message === 'There is an account with that nickname') {
      return 'Акаунт з таким нікнеймом вже існує';
    } else if (
      errorsObj?.info?.nickname &&
      errorsObj?.info?.nickname.includes('There is an account with that nickname')
    ) {
      return 'Користувач з таким нікнеймом, вже зареєстрований';
    } else if (
      errorsObj?.info?.name &&
      !errorsObj?.info?.surname &&
      errorsObj.info?.name.includes('Name is not correct')
    ) {
      return "Вказано некоректне ім'я";
    } else if (
      errorsObj?.info?.surname &&
      !errorsObj?.info?.name &&
      errorsObj?.info?.surname.includes('Surname is not correct')
    ) {
      return 'Вказано некоректне прізвище';
    } else if (
      errorsObj?.info?.surname &&
      errorsObj?.info?.surname.includes('Surname is not correct') &&
      errorsObj?.info?.name &&
      errorsObj?.info?.name.includes('Name is not correct')
    ) {
      return "Вказано некоректне прізвище та ім'я";
    } else if (
      errorsObj?.info?.result === 'name: Name is not correct, surname: Surname is not correct'
    ) {
      return "Вказано некоректне прізвище та ім'я";
    } else if (errorsObj?.info?.result === 'name: Name is not correct') {
      return "Вказано некоректне ім'я";
    } else if (errorsObj?.info?.result === 'surname: Surname is not correct') {
      return 'Вказано некоректне прізвище';
    } else if (errorsObj?.info?.result === "User have active order. Can't cancel subscription") {
      return 'Неможливо зараз скасувати підписку! У вас є активні замовлення!';
    } else if (
      errorsObj?.info?.result ===
      'nickname: You can register a nickname only in the Latin alphabet or symbol'
    ) {
      return 'Нікнейм може складатись тільки з латинських літер!';
    } else if (errorsObj?.info?.message === 'Invalid email or password') {
      return 'Не вірний логін або пароль';
    } else if (
      !errorsObj?.info?.auth &&
      typeof errorsObj?.info === 'string' &&
      errorsObj?.info?.includes('There is no user with email')
    ) {
      return 'Така електронна пошта не зареєстрована';
    } else if (errorsObj?.info?.auth === 'Account is not activated') {
      return 'Акаунт не активований! Перевірте електронну пошту.';
    } else if (errorsObj?.info?.result && errorsObj?.info?.result.includes("isn't activated")) {
      return 'Акаунт не активований! Перевірте електронну пошту.';
    } else if (errorsObj?.info?.number === 'має відповідати шаблону "\\+[0-9]+"') {
      return 'Номер телефону має відповідати шаблону +380*********';
    } else if (
      errorsObj?.info?.result &&
      errorsObj?.info?.result === 'User with active orders cannot delete account'
    ) {
      return 'User with active orders cannot delete account';
    } else if (
      errorsObj?.info?.result &&
      errorsObj?.info?.result === 'The selected photo is not in a supported format'
    ) {
      return 'Обрані фото мають не коректний формат';
    } else if (
      errorsObj?.info?.result &&
      errorsObj?.info?.result.includes("Promotion code doesn't exist")
    ) {
      return 'Вказаний код не дійсний!';
    } else if (
      errorsObj?.info?.result &&
      errorsObj?.info?.result.includes('User has already activated promotion code')
    ) {
      return 'Вказаний код не дійсний!';
    } else if (
      errorsObj?.info?.result &&
      errorsObj?.info?.result.includes('Owner promotion code is blocked')
    ) {
      return 'Вказаний код не дійсний!';
    }
  } else if (errorsObj?.result) {
    if (
      errorsObj?.result &&
      errorsObj?.result.includes('Account with email') &&
      errorsObj?.result.includes("doesn't exists")
    ) {
      return 'Такого акаунту не існує!';
    } else if (errorsObj?.result && errorsObj?.result === 'Authentication failed') {
      return 'Не вірний пароль!';
    } else if (errorsObj?.result && errorsObj?.result === 'The account is temporarily blocked') {
      return 'Акаунт заблоковано!';
    } else if (errorsObj?.result && errorsObj?.result === 'The account is permanently blocked') {
      return 'Акаунт заблоковано повністю!';
    } else if (
      errorsObj?.result &&
      errorsObj?.result === 'The account is permanently blocked by Admin'
    ) {
      return 'Акаунт заблоковано адміністратором!';
    } else {
      return errorsObj;
    }
  } else if (errorsObj?.message) {
    if (errorsObj?.message === 'Account can`t create more then 1 service') {
      return 'Ви вичерпали ліміт доступних товарів!';
    } else if (errorsObj?.message === 'Account can`t create more then 5 services') {
      return 'Ви вичерпали ліміт доступних товарів у пробному тарифі!';
    } else if (errorsObj?.message === "Service isn't active") {
      return 'Товар не активний!';
    } else if (errorsObj?.message === 'Only premium users can activate services') {
      return 'Товар не активовано!';
    } else if (errorsObj?.message.includes('99999999')) {
      return 'Ціна занадто висока! Максимально 99999999';
    } else {
      return errorsObj;
    }
  } else {
    return errorsObj;
  }
};
